module.exports = __webpack_public_path__ + "img/no-table-illustration.9dd8a62e.png";